import { Menu } from "@mui/material";
import { useRef, useState } from "react";
import type { CalculationType } from "../../../../../../../../api/types/fieldConfigurationTypes";
import useAvailableCalculationTypes from "../hooks/useAvailableCalculationTypes";
import CalculationMenuItem from "./custom-field/CalculationMenuItem";
import CustomCalculationOptionsMenu from "./custom-field/CustomCalculationOptionsMenu";

interface Props {
  anchorEl: HTMLElement | null;
  onCalculationItemClick: (calculationType: CalculationType) => void;
  onClose: () => void;
}

const AddFieldMenu = ({ anchorEl, onCalculationItemClick, onClose }: Props) => {
  const availableCalculationTypeOptions = useAvailableCalculationTypes();
  const [calculationMenuItemAnchor, setCalculationMenuItemAnchor] = useState<HTMLElement | null>(null);
  const customCalculationOptionsMenuRef = useRef<HTMLDivElement>(null);

  const handleCustomCalculationItemClick = (calculationType: CalculationType) => {
    onCalculationItemClick(calculationType);
    onClose();
  };

  const handleCalculationMenuItemClick = (target: HTMLElement) => {
    setCalculationMenuItemAnchor((prev) => (prev ? null : target));
  };

  const handleCalculationMenuItemClose = () => {
    setCalculationMenuItemAnchor(null);
  };

  const handleMouseLeave = (target: EventTarget | null) => {
    if (target instanceof Node && customCalculationOptionsMenuRef.current?.contains(target)) {
      return;
    }
    setCalculationMenuItemAnchor(null);
  };

  return (
    <>
      <Menu
        open={true}
        anchorEl={anchorEl}
        onClose={onClose}
        slotProps={{ paper: { sx: { width: anchorEl?.clientWidth } } }}
      >
        <CalculationMenuItem
          onMouseEnter={setCalculationMenuItemAnchor}
          onMouseLeave={handleMouseLeave}
          onClick={handleCalculationMenuItemClick}
        />
      </Menu>
      <CustomCalculationOptionsMenu
        ref={customCalculationOptionsMenuRef}
        selectedCalculationType={undefined}
        calculationMenuItemAnchor={calculationMenuItemAnchor}
        onClose={handleCalculationMenuItemClose}
        onCustomCalculationItemClick={handleCustomCalculationItemClick}
        availableCalculationTypeOptions={availableCalculationTypeOptions}
      />
    </>
  );
};

export default AddFieldMenu;
